import {
  BackupAction,
  LOAD_BACKUP,
  LOAD_BACKUP_FAIL,
  LOAD_BACKUP_SUCCESS,
  LoadBackupFail,
  LoadBackupSuccess
} from '../actions';
import {LoadBackup} from "../actions/backup.action";

export interface IWebsiteBackupState {
  websiteId: number;
  entities: {[id: string]: any};
  loading: boolean;
  loaded: boolean;
}

export interface IBackupState {
  entities: {[websiteId: number]: IWebsiteBackupState};
}

export const initialState: IBackupState = {
  entities: {}
};

export function reducer(state: IBackupState = initialState, action: BackupAction): IBackupState {
  let payload: any;

  switch (action.type) {

    case LOAD_BACKUP:
      payload = (<LoadBackup>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload]: {
            ...state[payload],
            loading: true,
            loaded: false
          }
        }
      };

    case LOAD_BACKUP_SUCCESS:
      payload = (<LoadBackupSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            entities: payload.entities,
            loading: false,
            loaded: true
          }
        }
      };

    case LOAD_BACKUP_FAIL:
      payload = (<LoadBackupFail>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: false,
            loaded: true
          }
        }
      };
  }

  return state;
}
